export { default as KemtaiClient } from './client';
import KemtaiService from './service';
export default KemtaiService;
//# sourceMappingURL=index.js.map